import CodeEntryModal from 'app/components/WalletModals/CodeEntryModal';
import EmailConnectModal from 'app/components/WalletModals/EmailConnectModal';
import WalletOptionModal from 'app/components/WalletModals/WalletOptionModal';
import { useConnectWallet } from 'app/contexts/ConnectWalletContext';
import { walletFlowType } from 'app/contexts/ConnectWalletContext/constant';
import React from 'react';
import MetamaskErrorModal from 'app/components/WalletModals/MetamaskErrorModal';
import Modal from 'app/components/Modal';
import NftSuccessModal from 'app/components/WalletModals/NftSuccessModal';
import AddressSelectModal from 'app/components/WalletModals/AddressSelectModal';

const ConnectWalletFlow = () => {
  const {
    walletAddress,
    claimWalletAddress,
    flowType,
    onMetamaskClick,
    onNasWalletClick,
    isEmailSubmitted,
    isLoading,
    error,
    email,
    clearError,
    onEmailSubmit,
    onContact,
    onCodeSubmit,
    getCode,
    isRedirectLPError,
    isMetamskErrorModal,
    closeMetamaskErrorModal,
    resetFlow,
    userWalletList,
    onAlternateAddressSelect,
    isNftClaimFlow,
    walletType,
  } = useConnectWallet();

  const renderWalletFlow = ({ type }) => {
    switch (type) {
      case walletFlowType.WALLET_SELECT:
        return (
          <WalletOptionModal
            open={!!flowType}
            onClose={resetFlow}
            walletList={[
              {
                name: 'Nas Wallet',
                extraInfo: '(Easy signup/login)',
                logoType: 'nasLogo',
                onClick: onNasWalletClick,
              },
              {
                name: 'Metamask',
                logoType: 'metamaskLogo',
                onClick: onMetamaskClick,
              },
            ]}
            isRedirectLPError={isRedirectLPError}
            isLoading={isLoading}
            isNftClaimFlow={isNftClaimFlow}
          />
        );
      case walletFlowType.NAS_WALLET:
        return isEmailSubmitted ? (
          <CodeEntryModal
            email={email}
            open={!!flowType}
            onContact={onContact}
            onResendOtp={getCode}
            onSuccess={onCodeSubmit}
            onChange={clearError}
            isLoading={isLoading}
            error={error}
            onClose={resetFlow}
          />
        ) : (
          <EmailConnectModal
            open={!!flowType}
            isLoading={isLoading}
            error={error}
            clearError={clearError}
            onSubmit={onEmailSubmit}
            onClose={resetFlow}
          />
        );
      case walletFlowType.CLAIM_NFT:
        return !!error ? (
          <Modal open={!!error} onClose={() => {}} showCloseIcon={false}>
            {error}
          </Modal>
        ) : (
          <NftSuccessModal
            open={true}
            onSuccess={() => resetFlow?.({ forced: true })}
            address={claimWalletAddress}
            walletType={walletType}
          />
        );
      case walletFlowType.ADDRESS_CHANGE:
        return (
          <AddressSelectModal
            open={true}
            list={userWalletList}
            isLoading={isLoading}
            onSuccess={onAlternateAddressSelect}
          />
        );
      case walletFlowType.ERROR:
        return (
          <Modal open={!!error} onClose={() => {}} showCloseIcon={false}>
            {error}
          </Modal>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      {renderWalletFlow({ type: flowType })}
      <MetamaskErrorModal
        open={isMetamskErrorModal}
        onClose={closeMetamaskErrorModal}
      />
    </div>
  );
};

export default ConnectWalletFlow;
